import React from 'react'

const ErrorPage = () => {
  return (
    <div className='h-screen flex flex-col justify-center items-center text-6xl p-3'>
      <h1 className='border-solid border-2 p-2 rounded-lg'>Error Page</h1>
    </div>
  )
}

export default ErrorPage